import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const SCHEMA = Object.freeze({});
const RECORD = generateSchema(SCHEMA);
const KEYS: any = generateKeys(SCHEMA);

export class TaskCompletionTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.task_list_completion_message;
  }

  get properties() {
    return this.toJS();
  }
}
